<template>
    <span>
        <button class="btn btn-md is-ghost" @click="$modal.show('create-email-account')">{{ lang('Lägg till', 'Add') }}</button>

        <form-modal
            :title="lang('Skapa e-postkonto','Create e-mail account')"
            name="create-email-account"
            method="post"
            :action="actionUrl"
            :redirect-to="route('front.my-pages.broadband.index')"
            :primary-button-text="lang('Spara','Save')"
            :close-button-text="lang('Avbryt','Cancel')"
        >
            <div>
                <div class="flex flex-col md:flex-row items-center mb-lg">
                    <div class="w-full">
                        <text-input
                            :label="lang('E-postnamn','E-mail')"
                            name="email_username"
                            :required="true"
                            :autofocus="true"
                        />
                    </div>
                    <div class="text-lg mx-xl mb-xl">@</div>
                    <div class="w-full">
                        <div class="textfield-select">
                            <select-input
                                name="domain"
                                :options="domainOptions"
                                :required="true"
                            >
                                {{ lang('Domän','Domain') }}
                            </select-input>
                        </div>
                    </div>
                </div>

                <h5 class="mb-2xl">{{ lang('Kontotyp','Account type') }}</h5>
                <div class="flex flex-col md:flex-row md:items-center mb-lg">
                    <div class="mr-4xl">
                        <div class="block mb-md">
                            <radio-input
                                v-model="type"
                                name="type"
                                value="account"
                                :required="true"
                            >
                                {{ lang('Nytt konto','New account') }}
                            </radio-input>
                        </div>
                        <div class="block mb-md md:mb-0">
                            <radio-input
                                v-model="type"
                                name="type"
                                value="alias"
                                :required="true"
                            >
                                {{ lang('Vidarebefodring','Forwarding') }}
                            </radio-input>
                        </div>
                    </div>
                    <div class="rounded bg-neutral-lighter py-lg px-xl">
                        <div v-if="type === 'account'">
                            {{ lang(
                                'Skapa ett nytt epost-konto med en egen inbox. Du väljer själv bland våra epost-domäner.',
                                'Create a new e-mail account with its own inbox. You choose between our domains and set your own password.'
                            ) }}
                        </div>
                        <div v-else-if="type === 'alias'">
                            {{ lang(
                                'Skapa en ny adress för vidarebefordran till en eller flera andra epost-adresser. Du väljer själv bland våra epost-domäner.',
                                'Create a new address which only forwards e-mails to one or several other emails.'
                            ) }}
                        </div>
                    </div>
                </div>

                <div v-if="type ==='account'">
                    <h5 class="mt-3xl mb-2xl">{{ lang('Lösenord för nytt konto','Password for new account') }}</h5>
                    <div class="flex flex-col md:flex-row mb-lg">
                        <div class="w-full md:mr-lg">
                            <password-input
                                :label="lang('Nytt lösenord','New password')"
                                name="password"
                                :required="true"
                            />
                        </div>

                        <div class="w-full md:ml-lg">
                            <text-input
                                :label="lang('Bekräfta lösenord','Confirm password')"
                                type="password"
                                name="password_confirmation"
                                :required="true"
                            />
                        </div>
                    </div>
                </div>

                <div v-else-if="type ==='alias'">
                    <text-input
                        :label="lang('Skicka till','Send to')"
                        name="send_to"
                        :required="true"
                    />

                    <info-box>{{ lang('Du kan ange flera kommaseparerade e-postadresser','You can add several comma separated e-mail address') }}.</info-box>
                </div>
            </div>
        </form-modal>
    </span>
</template>

<script>
    export default {
        props: {
            domainOptions: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                type: 'account',
            };
        },

        computed: {
            actionUrl() {
                if (this.type === 'alias') {
                    return route('front.my-pages.api.email-aliases.store');
                }

                return route('front.my-pages.api.email-accounts.store');
            },
        },
    };
</script>